export type ChatMemoryScope = 'site' | 'agent';

// Sidebar visibility ---------------------------------------------------------

const SIDEBAR_KEY = 'dopo:chat:sidebar';

export function getIsSidebarVisible(): boolean {
  try {
    return sessionStorage.getItem(SIDEBAR_KEY) === '1';
  } catch {
    return false;
  }
}

export function setIsSidebarVisible(v: boolean): void {
  try {
    sessionStorage.setItem(SIDEBAR_KEY, v ? '1' : '0');
  } catch {}
}

// Conversation id persistence (soft resume) ----------------------------------
// Optional suffix (e.g., wid) prevents cross-widget mismatches for site scope.
function convIdKey(scope: 'site' | 'agent', agentId: string | null, suffix?: string): string {
  const base = scope === 'agent'
    ? `dopo:chat:convId:agent:${agentId || ''}`
    : 'dopo:chat:convId:site';
  return suffix ? `${base}:wid:${suffix}` : base;
}

export function saveConversationId(
  scope: 'site' | 'agent',
  agentId: string | null,
  id: string,
  suffix?: string
): void {
  const key = convIdKey(scope, agentId, suffix);
  try {
    sessionStorage.setItem(key, id);
  } catch {}
}

export function loadConversationId(
  scope: 'site' | 'agent',
  agentId: string | null,
  suffix?: string
): string | null {
  const key = convIdKey(scope, agentId, suffix);
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function clearConversationId(
  scope: 'site' | 'agent',
  agentId: string | null,
  suffix?: string
): void {
  const key = convIdKey(scope, agentId, suffix);
  try {
    sessionStorage.removeItem(key);
  } catch {}
}

// Greeting idempotency -------------------------------------------------------

function greetedKey(
  modeTag: 'widget' | 'test' | 'unknown',
  scope: 'site' | 'agent',
  agentId: string | null
): string {
  const convTag = 'new';
  const agentTag = String(agentId || 'global');
  return `dopo:chat:greeted:${modeTag}:${scope}:${agentTag}:${convTag}`;
}

export function wasGreeted(
  scope: 'site' | 'agent',
  agentId: string | null,
  modeTag: 'widget' | 'test' | 'unknown' = 'unknown'
): boolean {
  const key = greetedKey(modeTag, scope, agentId);
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function markGreeted(
  scope: 'site' | 'agent',
  agentId: string | null,
  modeTag: 'widget' | 'test' | 'unknown' = 'unknown'
): void {
  const key = greetedKey(modeTag, scope, agentId);
  try {
    sessionStorage.setItem(key, '1');
  } catch {}
}

// Visitor id convenience -----------------------------------------------------

export function getVisitorId(): string | null {
  try {
    return localStorage.getItem('dopomogai_visitor_id') || null;
  } catch {
    return null;
  }
}
